module.exports = __webpack_public_path__ + "assets/img/8d6dd1a650f5c73be5bbab26bad7e5c1.svg";